import { render, staticRenderFns } from "./ICalendar.vue?vue&type=template&id=56fe5602&"
import script from "./ICalendar.vue?vue&type=script&lang=ts&"
export * from "./ICalendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports